import styled from 'styled-components';

// CONSTANTS
import { WHITE, BLACK, SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ContentWrap = styled.div`
  .section {
    padding-top: 68px;
    padding-bottom: 68px;

    &:first-of-type {
      padding-top: 144px;
      padding-bottom: 48px;
    }

    ${breakpoints.down('sm')} {
      padding-top: 40px;
      padding-bottom: 40px;

      &:first-of-type {
        padding-top: 40px;
        padding-bottom: 40px;
      }
    }

    ${breakpoints.down('xs')} {
      text-align: center;
    }
  }

  .hero {
    &__title {
      white-space: pre-line;
      line-height: 7.2rem;
      font-weight: 500;

      ${breakpoints.down('sm')} {
        font-size: 4.2rem;
        line-height: 5rem;
      }
    }

    &__subtitle {
      margin-bottom: 68px;
    }

    &__img {
      ${breakpoints.down('xs')} {
        max-width: 100%;
      }
    }

    &__number-input {
      position: relative;
      max-width: 435px;

      .MuiInputBase-root {
        border-radius: 12px;
      }

      .MuiInputBase-input {
        padding-top: 1.8rem;
        padding-bottom: 1.8rem;
        padding-right: 1.8rem;

        &::placeholder {
          color: ${SANTAS_GRAY};
        }
      }

      .MuiOutlinedInput-adornedEnd {
        padding-right: 0;
      }

      .MuiButtonBase-root {
        flex-shrink: 0;
        border-radius: 0 12px 12px 0;
        width: 149px;
        padding: 2.2rem 3rem;
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: ${p => p.theme.palette.primary.main};
      }
    }

    &--iframe {
      .hero {
        &__title {
          line-height: 4.6rem;
          font-weight: 400;
        }

        &__subtitle {
          margin-bottom: 24px;
        }
      }

      &.section {
        padding-top: 112px;
        padding-bottom: 93px;
      }

      .pros-cons-list {
        margin-bottom: 24px;
      }

      .MuiGrid-container {
        ${breakpoints.down('xs')} {
          flex-direction: column-reverse;
        }
      }

      .MuiButton-root {
        ${breakpoints.down('xs')} {
          margin-bottom: 24px;
        }
      }
    }
  }

  .s-benefits {
    text-align: center;

    &__title {
      line-height: 7.2rem;
      font-weight: 500;
      margin-bottom: 80px;

      ${breakpoints.down('sm')} {
        font-size: 3.2rem;
        line-height: 4.6rem;
        margin-bottom: 40px;
      }
    }

    &__img {
      max-width: 100%;
    }
  }

  .c-benefits {
    text-align: center;

    &__title {
      line-height: 5.2rem;
      font-weight: 500;
      margin-bottom: 80px;

      ${breakpoints.down('sm')} {
        font-size: 3.2rem;
        line-height: 4.6rem;
        margin-bottom: 40px;
      }
    }

    &__img {
      max-width: 100%;
    }
  }

  .download-app {
    &__title {
      line-height: 5.2rem;
    }

    &__qr {
      text-align: center;
      margin-bottom: 30px;

      svg {
        padding: 15px;
        background-color: ${WHITE};
        border-radius: 5px;
        border: 5px solid ${BLACK};
      }
    }

    &__links {
      display: flex;
      justify-content: center;
      align-items: center;

      > a {
        line-height: 0;
      }

      > a:not(:last-of-type) {
        margin-right: 52px;
      }

      ${breakpoints.down('xs')} {
        flex-direction: column;

        > a:not(:last-of-type) {
          margin-right: 0;
          margin-bottom: 25px;
        }
      }
    }
  }
`;

export default ContentWrap;
